module.exports = __webpack_public_path__ + "media/E_illustration.e7aba705.mp3";